(function () {
  var MIN_HEADINGS = 3;
  var CONTENT_SEL = '.blog-post-content';
  var TOC_NAV_SEL = '[data-blog-article-toc]';
  var TOC_LIST_SEL = '[data-blog-article-toc-list]';

  function slugify(text) {
    return String(text)
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function init() {
    var nav = document.querySelector(TOC_NAV_SEL);
    var list = document.querySelector(TOC_LIST_SEL);
    var content = document.querySelector(CONTENT_SEL);
    if (!nav || !list || !content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < MIN_HEADINGS) {
      nav.hidden = true;
      return;
    }

    var usedIds = {};
    var fragment = document.createDocumentFragment();

    Array.prototype.forEach.call(headings, function (heading, index) {
      var label = (heading.textContent || '').trim();
      if (!label) return;

      var baseId = slugify(label) || 'section-' + (index + 1);
      var id = baseId;
      var n = 2;
      while (usedIds[id] || document.getElementById(id)) {
        id = baseId + '-' + n;
        n += 1;
      }
      usedIds[id] = true;

      if (!heading.id) heading.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'blog-article-toc__link';
      a.href = '#' + id;
      a.textContent = label;
      li.appendChild(a);
      fragment.appendChild(li);
    });

    if (!fragment.childNodes.length) {
      nav.hidden = true;
      return;
    }

    list.appendChild(fragment);
    nav.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
